import React from "react";

export default function Close(props) {
 return <div>Close</div>;
}
